import { Injectable } from '@angular/core';
import { ETransportService } from '../../enums/transportService.enum';

@Injectable()
export class TransportServicesService {
  /**
   * Retrieves a list of transport services from the `ETransportService` enum.
   * The returned list is formatted as strings with spaces replacing underscores and all characters in uppercase.
   * @returns {string[]} An array of formatted transport service names.
   */
  getServicesList(): string[] {
    return Object.keys(ETransportService).map((key) =>
      key.replace(/_/g, ' ').toUpperCase()
    );
  }
}
